import { z } from 'zod'
import { baseEntitySchema } from '../entity.js'
import { ruleFiringBatchSchema } from '../rule-firing-batch.js'

export const ruleFiringBatchEntitySchema = baseEntitySchema.merge(ruleFiringBatchSchema).extend({
  type: z.literal('rule-firing-batch'),
})
export type RuleFiringBatchEntity = z.infer<typeof ruleFiringBatchEntitySchema>

export function isRuleFiringBatch(entity?: unknown): entity is RuleFiringBatchEntity {
  return (
    entity != null &&
    typeof entity === 'object' &&
    (entity as { type?: unknown }).type === 'rule-firing-batch'
  )
}
